/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Homepage_DescriptionInputs */

const en_meta_homepage_description = /** @type {(inputs: Meta_Homepage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transform research papers and journals into audio with this AI text-to-speech tool. Easily pronounce technical words and skip citiations. Download now.`)
};

const es_meta_homepage_description = /** @type {(inputs: Meta_Homepage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforma artículos de investigación y revistas en audio con esta herramienta de texto a voz con IA. Pronuncia fácilmente palabras técnicas y omite citas. ¡Descárgala ahora!`)
};

/**
* | output |
* | --- |
* | "Transform research papers and journals into audio with this AI text-to-speech tool. Easily pronounce technical words and skip citiations. Download now." |
*
* @param {Meta_Homepage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_homepage_description = /** @type {((inputs?: Meta_Homepage_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Homepage_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_homepage_description(inputs)
	return en_meta_homepage_description(inputs)
});